module.exports = __webpack_public_path__ + "img/reglamentoinfantilexhibicion.6344dbe7.png";